import { getClientAwardsExcelData } from './client-awards';
import { getUpcomingProjectsExcelData } from './upcoming-projects';
import { getClientSummaryExcelData } from './client-summary';
import { getFunderReportExcelData } from './funder-report';
import { getOpportunityReviewExcelData } from './opportunity-review';
import { getDeadlinesReportExcelData } from './deadlines-report';

export const EXCEL_EXPORTERS = {
  client_awards: getClientAwardsExcelData,
  upcoming_projects: getUpcomingProjectsExcelData,
  client_report: getClientSummaryExcelData,
  funder_report: getFunderReportExcelData,
  opportunity_review: getOpportunityReviewExcelData,
  deadlines_report: getDeadlinesReportExcelData,
};
